<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 w-full">
  @for (item of items(); track item) {
    <div
      class="bg-white dark:bg-neutral-2 border border-neutral-3 rounded-3xl overflow-hidden flex flex-col h-full shadow-sm"
    >
      <!-- Top banner skeleton -->
      <div class="h-32 bg-gray-3 dark:bg-gray-2 p-4 flex flex-col justify-between">
        <div class="flex justify-between items-start">
          <ngx-skeleton-loader
            [theme]="{ width: '90px', height: '24px', 'border-radius': '9999px', margin: '0' }"
            animation="pulse"
          />
          <ngx-skeleton-loader
            [theme]="{ width: '60px', height: '24px', 'border-radius': '9999px', margin: '0' }"
            animation="pulse"
          />
        </div>
        <div class="flex justify-between items-end">
          <ngx-skeleton-loader
            [theme]="{ width: '120px', height: '18px', 'border-radius': '6px', margin: '0' }"
            animation="pulse"
          />
          <ngx-skeleton-loader
            [theme]="{ width: '50px', height: '16px', 'border-radius': '6px', margin: '0' }"
            animation="pulse"
          />
        </div>
      </div>

      <!-- Body content skeleton -->
      <div class="p-6 flex flex-col flex-1 gap-4">
        <div>
          <ngx-skeleton-loader
            [theme]="{ width: '80%', height: '22px', 'border-radius': '6px', margin: '0 0 8px 0' }"
            animation="pulse"
          />
          <ngx-skeleton-loader
            [theme]="{ width: '45%', height: '14px', 'border-radius': '4px', margin: '0' }"
            animation="pulse"
          />
        </div>

        <!-- Financial details skeleton -->
        <div class="grid grid-cols-2 gap-4 py-3 border-y border-neutral-3">
          <div>
            <ngx-skeleton-loader
              [theme]="{ width: '70px', height: '12px', 'border-radius': '4px', margin: '0 0 6px 0' }"
              animation="pulse"
            />
            <ngx-skeleton-loader
              [theme]="{ width: '100px', height: '22px', 'border-radius': '6px', margin: '0' }"
              animation="pulse"
            />
          </div>
          <div>
            <ngx-skeleton-loader
              [theme]="{ width: '65px', height: '12px', 'border-radius': '4px', margin: '0 0 6px 0' }"
              animation="pulse"
            />
            <ngx-skeleton-loader
              [theme]="{ width: '55px', height: '22px', 'border-radius': '6px', margin: '0' }"
              animation="pulse"
            />
          </div>
        </div>

        <!-- Application progress skeleton -->
        <div class="flex flex-col gap-2 mt-auto">
          <div class="flex justify-between">
            <ngx-skeleton-loader
              [theme]="{ width: '75px', height: '14px', 'border-radius': '4px', margin: '0' }"
              animation="pulse"
            />
            <ngx-skeleton-loader
              [theme]="{ width: '60px', height: '14px', 'border-radius': '4px', margin: '0' }"
              animation="pulse"
            />
          </div>
          <ngx-skeleton-loader
            [theme]="{ width: '100%', height: '8px', 'border-radius': '9999px', margin: '0' }"
            animation="pulse"
          />
        </div>
      </div>
    </div>
  }
</div>
